import React, { useEffect, useMemo, useRef, useState } from 'react';
import useResponsive from '../utils/useResponsive';
import { formatearMoneda } from '../utils/formatMoney';
import { hoyISO, primerDiaMesISO } from '../utils/fechaHoy';
import FiltroUsuarios from './FiltroUsuarios';
import { useFiltroUsuarios } from '../filtroUsuarios';

const API = '/api';
const money = (v) => `$${formatearMoneda(Math.round(Number(v) || 0))}`;

const BANCOS = ['Afirme', 'Banorte', 'Banamex', 'Banregio', 'HSBC', 'Santander', 'Scotiabank'];
const MESES = [
  { v: 1, l: 'Enero' }, { v: 2, l: 'Febrero' }, { v: 3, l: 'Marzo' }, { v: 4, l: 'Abril' },
  { v: 5, l: 'Mayo' }, { v: 6, l: 'Junio' }, { v: 7, l: 'Julio' }, { v: 8, l: 'Agosto' },
  { v: 9, l: 'Septiembre' }, { v: 10, l: 'Octubre' }, { v: 11, l: 'Noviembre' }, { v: 12, l: 'Diciembre' },
];
const NOMBRE_MES = (v) => MESES.find(m => m.v === v)?.l || v;
// Nombres de cliente vienen a veces en MAYÚSCULAS, a veces ya en Mayúsculas
// y minúsculas — se normaliza para que se vea consistente.
const tituloCase = (s) => (s || '').toLowerCase().replace(/(^|[\s-])\S/g, (c) => c.toUpperCase());

const STATUS_STYLE_R1 = {
  'En Evaluación': { bg: '#e6edf9', color: '#2952a3' },
  'Autorizados': { bg: '#e3f2e6', color: '#237a3d' },
  'Avalúo': { bg: '#fdeccb', color: '#93590a' },
  'Firmados': { bg: '#e6f3fb', color: '#0f6a94' },
};

const TABS = [
  { id: 'historico', label: '1 · Histórico de Prospectos' },
  { id: 'evaluacion', label: '2 · Entradas a Evaluación' },
  { id: 'firmados', label: '3 · Firmados por Fecha' },
  { id: 'porvencer', label: '4 · Por Vencer Autorización' },
  { id: 'rechazos', label: '5 · Rechazos y Desistimientos' },
  { id: 'formalizacion', label: '6 · Expediente Pendiente Formalización' },
];

const CHECKLIST_EXPEDIENTE = [
  { campo: 'chk_cuenta_domiciliar', label: 'Cuenta a Domiciliar', linea1: 'Cuenta a', linea2: 'Domiciliar' },
  { campo: 'chk_biometria_huellas', label: 'Biometría de Huellas', linea1: 'Biometría de', linea2: 'Huellas' },
  { campo: 'chk_aviso_avaluo', label: 'Aviso de Avalúo', linea1: 'Aviso de', linea2: 'Avalúo' },
  { campo: 'chk_visita_domiciliaria', label: 'Visita Domiciliaria', linea1: 'Visita', linea2: 'Domiciliaria' },
  { campo: 'chk_documentos_notaria', label: 'Documentación Notaría', linea1: 'Documentación', linea2: 'Notaría' },
  { campo: 'chk_documentos_banco', label: 'Documentación Banco', linea1: 'Documentación', linea2: 'Banco' },
];


async function descargarPdf(url, nombreArchivo) {
  const r = await fetch(url);
  if (!r.ok) return false;
  const blob = await r.blob();
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = nombreArchivo;
  link.click();
  URL.revokeObjectURL(link.href);
  return true;
}

const toggle = (arr, setArr, v) => setArr(arr.includes(v) ? arr.filter(x => x !== v) : [...arr, v]);

const sh = {
  toolbar: { display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap', marginBottom: 16 },
  filters: { display: 'flex', gap: 18, flexWrap: 'wrap' },
  field: { display: 'flex', flexDirection: 'column', gap: 6 },
  label: { fontSize: 11, fontWeight: 'bold', color: '#6b7280', textTransform: 'uppercase', letterSpacing: 0.4 },
  select: { border: '1px solid #d1d5db', borderRadius: 7, padding: '7px 10px', fontSize: 13, minWidth: 140, fontFamily: 'inherit' },
  exportBtn: { display: 'inline-flex', alignItems: 'center', gap: 8, backgroundColor: '#16794f', color: 'white', border: 'none', fontSize: 12.5, fontWeight: 'bold', borderRadius: 8, padding: '9px 15px', cursor: 'pointer', whiteSpace: 'nowrap' },
  tableScroll: { overflowX: 'auto', border: '1px solid #e5e7eb', borderRadius: 10 },
  table: { width: '100%', borderCollapse: 'collapse', fontVariantNumeric: 'tabular-nums' },
  th: { textAlign: 'left', fontSize: 10.5, fontWeight: 'bold', color: '#6b7280', textTransform: 'uppercase', letterSpacing: 0.3, backgroundColor: '#f9fafb', padding: '6px 10px', borderBottom: '1px solid #e5e7eb' },
  thSub: { textAlign: 'right', fontSize: 9.5, fontWeight: 'bold', color: '#6b7280', backgroundColor: '#f3f4f6', padding: '4px 10px', borderBottom: '1px solid #e5e7eb' },
  td: { padding: '4px 10px', borderBottom: '1px solid #e5e7eb', fontSize: 12.5 },
  num: { textAlign: 'right' },
  bancoGroup: { fontWeight: 'bold', backgroundColor: '#fff2e8' },
  totalGeneralHeader: { fontWeight: 'bold', backgroundColor: '#1a3a6e' },
  totalsRow: { fontWeight: 'bold', borderTop: '2px solid #e5e7eb', backgroundColor: '#f9fafb' },
  empty: { padding: 24, textAlign: 'center', color: '#6b7280', fontSize: 13 },
  pill: (bg, color) => ({ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 11.5, fontWeight: 600, borderRadius: 999, padding: '2px 10px', backgroundColor: bg, color }),
  liveBadge: { display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 11.5, fontWeight: 'bold', color: '#16794f', backgroundColor: '#e7f6ee', border: '1px solid #b9e6cc', borderRadius: 999, padding: '5px 12px' },
  buscarBtn: { border: 'none', borderRadius: 7, padding: '8px 16px', fontSize: 13, fontWeight: 'bold', cursor: 'pointer', backgroundColor: '#1a3a6e', color: 'white' },
  // Selector desplegable con checkboxes: mismo patrón visual que el filtro de
  // Status del listado de Hipotecas (SeguimientoClientes.jsx: statusBox/statusBtn/statusMenu).
  dropdownBox: { position: 'relative' },
  dropdownBtn: { padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, backgroundColor: 'white', cursor: 'pointer', textAlign: 'left', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 },
  dropdownMenu: { position: 'absolute', top: '100%', left: 0, marginTop: 4, backgroundColor: 'white', border: '1px solid #d1d5db', borderRadius: 6, boxShadow: '0 4px 12px rgba(0,0,0,0.15)', zIndex: 20, maxHeight: 320, overflowY: 'auto', padding: 6 },
  dropdownItem: { display: 'flex', alignItems: 'center', gap: 8, padding: '6px 8px', fontSize: 13, cursor: 'pointer', borderRadius: 4, whiteSpace: 'nowrap' },
  dropdownDivider: { borderTop: '1px solid #e5e7eb', margin: '4px 0' },
};

function DropdownCheckbox({ label, opciones, seleccion, onToggle, onClear, todosLabel = 'Todos', ancho = 190 }) {
  const [open, setOpen] = useState(false);
  const resumen = seleccion.length === 0
    ? todosLabel
    : seleccion.length === 1
      ? (opciones.find(o => o.v === seleccion[0])?.l ?? String(seleccion[0]))
      : `${seleccion.length} seleccionados`;
  return (
    <div style={sh.field}>
      <label style={sh.label}>{label}</label>
      <div style={sh.dropdownBox}>
        <button type="button" style={{ ...sh.dropdownBtn, width: ancho }} onClick={() => setOpen(o => !o)}>
          <span>{resumen}</span>
          <span style={{ color: '#6b7280' }}>▾</span>
        </button>
        {open && (
          <>
            <div onClick={() => setOpen(false)} style={{ position: 'fixed', inset: 0, zIndex: 15 }} />
            <div style={{ ...sh.dropdownMenu, minWidth: ancho }}>
              <label style={sh.dropdownItem}>
                <input type="checkbox" checked={seleccion.length === 0} onChange={onClear} />
                <strong>{todosLabel}</strong>
              </label>
              <div style={sh.dropdownDivider} />
              {opciones.map(o => (
                <label key={o.v} style={sh.dropdownItem}>
                  <input type="checkbox" checked={seleccion.includes(o.v)} onChange={() => onToggle(o.v)} />
                  {o.l}
                </label>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

// Filas de encabezado (colSpan por mes + Total) compartidas por los
// Reportes 1, 2 y 3 cuando hay más de un mes seleccionado.
function EncabezadoMeses({ colsFijas, meses }) {
  return (
    <>
      <tr>
        {colsFijas.map(c => <th key={c} style={sh.th} rowSpan={2}>{c}</th>)}
        {meses.map(m => <th key={m} style={{ ...sh.th, textAlign: 'center' }} colSpan={2}>{NOMBRE_MES(m)}</th>)}
        <th style={{ ...sh.th, textAlign: 'center' }} colSpan={2}>Total</th>
      </tr>
      <tr>
        {meses.map(m => (
          <React.Fragment key={m}>
            <th style={sh.thSub}># Casos</th>
            <th style={sh.thSub}>Monto $</th>
          </React.Fragment>
        ))}
        <th style={sh.thSub}># Casos</th>
        <th style={sh.thSub}>Monto $</th>
      </tr>
    </>
  );
}

function CeldasMeses({ meses, porMes, total, destacado }) {
  const numStyle = destacado ? { ...sh.td, ...sh.num, fontWeight: 'bold' } : { ...sh.td, ...sh.num };
  return (
    <>
      {meses.map(m => (
        <React.Fragment key={m}>
          <td style={numStyle}>{(porMes[m] || {}).cantidad ?? 0}</td>
          <td style={numStyle}>{money((porMes[m] || {}).monto)}</td>
        </React.Fragment>
      ))}
      <td style={numStyle}>{total.cantidad}</td>
      <td style={numStyle}>{money(total.monto)}</td>
    </>
  );
}

function ReporteHistorico({ anios }) {
  const filtroUsuariosKey = useFiltroUsuarios().join(',');
  const [anioSel, setAnioSel] = useState([]);
  const [meses, setMeses] = useState([]);
  const [bancos, setBancos] = useState([]);
  const [datos, setDatos] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const construirQuery = () => {
    const params = new URLSearchParams();
    params.set('anios', anioSel.length ? anioSel.join(',') : 'todos');
    params.set('meses', meses.length ? meses.join(',') : 'todos');
    params.set('bancos', bancos.length ? bancos.join(',') : 'todos');
    return params.toString();
  };

  useEffect(() => {
    setLoading(true);
    setError('');
    fetch(`${API}/reportes-crm/historico-prospectos?${construirQuery()}`)
      .then(r => r.json())
      .then(d => (d.error ? setError(d.error) : setDatos(d)))
      .catch(() => setError('No se pudo cargar el reporte'))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [anioSel, meses, bancos, filtroUsuariosKey]);

  const exportar = () => descargarPdf(`${API}/reportes-crm/historico-prospectos/exportar?${construirQuery()}`, 'historico-prospectos.pdf');

  const grupos = useMemo(() => {
    if (!datos) return [];
    const porBanco = new Map();
    for (const f of datos.filas) {
      if (!porBanco.has(f.banco)) porBanco.set(f.banco, []);
      porBanco.get(f.banco).push(f);
    }
    return [...porBanco.entries()];
  }, [datos]);

  const multiMes = !!(datos && datos.meses && datos.meses.length > 1);
  const colCount = multiMes ? datos.meses.length * 2 + 4 : 4;

  return (
    <div>
      <div style={sh.toolbar}>
        <div style={sh.filters}>
          <DropdownCheckbox label="Año" opciones={anios.map(a => ({ v: a, l: String(a) }))} seleccion={anioSel} onToggle={v => toggle(anioSel, setAnioSel, v)} onClear={() => setAnioSel([])} ancho={110} />
          <DropdownCheckbox label="Mes" opciones={MESES} seleccion={meses} onToggle={v => toggle(meses, setMeses, v)} onClear={() => setMeses([])} ancho={190} />
          <DropdownCheckbox label="Banco" opciones={BANCOS.map(b => ({ v: b, l: b }))} seleccion={bancos} onToggle={v => toggle(bancos, setBancos, v)} onClear={() => setBancos([])} ancho={190} />
        </div>
        <button style={sh.exportBtn} onClick={exportar}>⬇ Exportar PDF</button>
      </div>

      {error && <div style={{ color: '#dc2626', marginBottom: 12 }}>{error}</div>}

      <div style={sh.tableScroll}>
        <table style={sh.table}>
          <thead>
            {multiMes ? (
              <EncabezadoMeses colsFijas={['Banco', 'Status']} meses={datos.meses} />
            ) : (
              <tr>
                <th style={sh.th}>Banco</th><th style={sh.th}>Status</th>
                <th style={{ ...sh.th, ...sh.num }}># Casos</th><th style={{ ...sh.th, ...sh.num }}>Monto $</th>
              </tr>
            )}
          </thead>
          <tbody>
            {loading && <tr><td colSpan={colCount} style={sh.empty}>Cargando...</td></tr>}
            {!loading && grupos.length === 0 && <tr><td colSpan={colCount} style={sh.empty}>Sin casos para el filtro seleccionado</td></tr>}
            {!loading && grupos.map(([banco, filas]) => (
              <React.Fragment key={banco}>
                <tr style={sh.bancoGroup}><td style={sh.td} colSpan={colCount}>{banco}</td></tr>
                {filas.map(f => (
                  <tr key={`${banco}-${f.status}`}>
                    <td style={sh.td} />
                    <td style={sh.td}><span style={sh.pill(STATUS_STYLE_R1[f.status].bg, STATUS_STYLE_R1[f.status].color)}>{f.status}</span></td>
                    {multiMes
                      ? <CeldasMeses meses={datos.meses} porMes={f.porMes} total={f.total} destacado />
                      : (<><td style={{ ...sh.td, ...sh.num }}>{f.total.cantidad}</td><td style={{ ...sh.td, ...sh.num }}>{money(f.total.monto)}</td></>)}
                  </tr>
                ))}
              </React.Fragment>
            ))}
            {!loading && datos && grupos.length > 0 && (
              <>
                <tr style={sh.totalGeneralHeader}><td style={{ ...sh.td, color: 'white' }} colSpan={colCount}>TOTAL GENERAL</td></tr>
                {datos.totalPorStatus.map(s => (
                  <tr key={s.status} style={sh.totalsRow}>
                    <td style={sh.td} />
                    <td style={sh.td}>{s.status}</td>
                    {multiMes
                      ? <CeldasMeses meses={datos.meses} porMes={s.porMes} total={s.total} />
                      : (<><td style={{ ...sh.td, ...sh.num }}>{s.total.cantidad}</td><td style={{ ...sh.td, ...sh.num }}>{money(s.total.monto)}</td></>)}
                  </tr>
                ))}
              </>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function ReporteRango({ tipo, anios }) {
  const filtroUsuariosKey = useFiltroUsuarios().join(',');
  const [anioSel, setAnioSel] = useState([]);
  const [meses, setMeses] = useState([]);
  const [datos, setDatos] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const endpoint = tipo === 'evaluacion' ? 'entradas-evaluacion' : 'firmados';
  const archivo = tipo === 'evaluacion' ? 'entradas-evaluacion.pdf' : 'firmados-periodo.pdf';
  const construirQuery = () => {
    const params = new URLSearchParams();
    params.set('anios', anioSel.length ? anioSel.join(',') : 'todos');
    params.set('meses', meses.length ? meses.join(',') : 'todos');
    return params.toString();
  };

  useEffect(() => {
    setLoading(true);
    setError('');
    fetch(`${API}/reportes-crm/${endpoint}?${construirQuery()}`)
      .then(r => r.json())
      .then(d => (d.error ? setError(d.error) : setDatos(d)))
      .catch(() => setError('No se pudo cargar el reporte'))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tipo, anioSel, meses, filtroUsuariosKey]);

  const exportar = () => descargarPdf(`${API}/reportes-crm/${endpoint}/exportar?${construirQuery()}`, archivo);

  const multiMes = !!(datos && datos.meses && datos.meses.length > 1);
  const colCount = multiMes ? datos.meses.length * 2 + 4 : 4;

  return (
    <div>
      <div style={sh.toolbar}>
        <div style={sh.filters}>
          <DropdownCheckbox label="Año" opciones={anios.map(a => ({ v: a, l: String(a) }))} seleccion={anioSel} onToggle={v => toggle(anioSel, setAnioSel, v)} onClear={() => setAnioSel([])} ancho={110} />
          <DropdownCheckbox label="Mes" opciones={MESES} seleccion={meses} onToggle={v => toggle(meses, setMeses, v)} onClear={() => setMeses([])} ancho={190} />
        </div>
        <button style={sh.exportBtn} onClick={exportar}>⬇ Exportar PDF</button>
      </div>

      {error && <div style={{ color: '#dc2626', marginBottom: 12 }}>{error}</div>}

      <div style={sh.tableScroll}>
        <table style={sh.table}>
          <thead>
            {multiMes ? (
              <EncabezadoMeses colsFijas={['Banco', 'Tipo de Crédito']} meses={datos.meses} />
            ) : (
              <tr><th style={sh.th}>Banco</th><th style={sh.th}>Tipo de Crédito</th><th style={{ ...sh.th, ...sh.num }}># Casos</th><th style={{ ...sh.th, ...sh.num }}>Monto $</th></tr>
            )}
          </thead>
          <tbody>
            {loading && <tr><td colSpan={colCount} style={sh.empty}>Cargando...</td></tr>}
            {!loading && datos && datos.filas.length === 0 && <tr><td colSpan={colCount} style={sh.empty}>Sin casos para el filtro seleccionado</td></tr>}
            {!loading && datos && datos.filas.map((f, i) => (
              <tr key={i}>
                <td style={sh.td}>{f.banco}</td><td style={sh.td}>{f.tipo_credito}</td>
                {multiMes
                  ? <CeldasMeses meses={datos.meses} porMes={f.porMes} total={f.total} destacado />
                  : (<><td style={{ ...sh.td, ...sh.num }}>{f.total.cantidad}</td><td style={{ ...sh.td, ...sh.num }}>{money(f.total.monto)}</td></>)}
              </tr>
            ))}
            {!loading && datos && datos.filas.length > 0 && (
              <tr style={sh.totalsRow}>
                <td style={sh.td} colSpan={2}>Total en el periodo</td>
                {multiMes
                  ? <CeldasMeses meses={datos.meses} porMes={datos.totalPorMes} total={datos.total} />
                  : (<><td style={{ ...sh.td, ...sh.num }}>{datos.total.cantidad}</td><td style={{ ...sh.td, ...sh.num }}>{money(datos.total.monto)}</td></>)}
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function ReportePorVencer() {
  const filtroUsuariosKey = useFiltroUsuarios().join(',');
  const [datos, setDatos] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch(`${API}/reportes-crm/por-vencer`)
      .then(r => r.json())
      .then(d => (d.error ? setError(d.error) : setDatos(d)))
      .catch(() => setError('No se pudo cargar el reporte'))
      .finally(() => setLoading(false));
  }, [filtroUsuariosKey]);

  const exportar = () => descargarPdf(`${API}/reportes-crm/por-vencer/exportar`, 'por-vencer-autorizacion.pdf');

  return (
    <div>
      <div style={sh.toolbar}>
        <span style={sh.liveBadge}>🟢 En vivo · siempre hoy</span>
        <button style={sh.exportBtn} onClick={exportar}>⬇ Exportar PDF</button>
      </div>

      {error && <div style={{ color: '#dc2626', marginBottom: 12 }}>{error}</div>}

      <div style={sh.tableScroll}>
        <table style={sh.table}>
          <thead>
            <tr>
              <th style={sh.th}>Cliente</th><th style={sh.th}>Banco</th>
              <th style={sh.th}>Fecha de Autorización</th><th style={sh.th}>Fecha de Vencimiento</th>
              <th style={{ ...sh.th, ...sh.num }}>Días Restantes</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={5} style={sh.empty}>Cargando...</td></tr>}
            {!loading && datos && datos.length === 0 && <tr><td colSpan={5} style={sh.empty}>No hay autorizaciones por vencer en los próximos 21 días</td></tr>}
            {!loading && datos && datos.map(f => {
              const urgente = f.dias_restantes <= 7;
              const medio = !urgente && f.dias_restantes <= 21;
              const rowStyle = urgente ? { backgroundColor: '#fde8e8' } : (medio ? { backgroundColor: '#fff4e0' } : undefined);
              const diasColor = urgente ? '#dc2626' : (medio ? '#c2740a' : undefined);
              return (
                <tr key={f.id} style={rowStyle}>
                  <td style={sh.td}>{f.nombre_cliente || '(Sin nombre)'}</td>
                  <td style={sh.td}>{f.banco}</td>
                  <td style={sh.td}>{f.fecha_autorizacion}</td>
                  <td style={sh.td}>{f.fecha_vencimiento}</td>
                  <td style={{ ...sh.td, ...sh.num, fontWeight: 'bold', color: diasColor }}>{f.dias_restantes}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function ReporteRechazos() {
  const filtroUsuariosKey = useFiltroUsuarios().join(',');
  const [desde, setDesde] = useState(primerDiaMesISO());
  const [hasta, setHasta] = useState(hoyISO());
  const [datos, setDatos] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const construirQuery = () => new URLSearchParams({ fecha_inicio: desde, fecha_fin: hasta }).toString();

  const buscar = () => {
    setLoading(true);
    setError('');
    fetch(`${API}/reportes-crm/rechazos-desistimientos?${construirQuery()}`)
      .then(r => r.json())
      .then(d => (d.error ? setError(d.error) : setDatos(d)))
      .catch(() => setError('No se pudo cargar el reporte'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { buscar(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [filtroUsuariosKey]);

  const exportar = () => descargarPdf(`${API}/reportes-crm/rechazos-desistimientos/exportar?${construirQuery()}`, 'rechazos-desistimientos.pdf');

  return (
    <div>
      <div style={sh.toolbar}>
        <div style={sh.filters}>
          <div style={sh.field}><label style={sh.label}>Desde</label><input type="date" style={sh.select} value={desde} onChange={e => setDesde(e.target.value)} /></div>
          <div style={sh.field}><label style={sh.label}>Hasta</label><input type="date" style={sh.select} value={hasta} onChange={e => setHasta(e.target.value)} /></div>
          <div style={sh.field}>
            <label style={sh.label}>&nbsp;</label>
            <button style={sh.buscarBtn} onClick={buscar}>{loading ? 'Buscando...' : 'Buscar'}</button>
          </div>
        </div>
        <button style={sh.exportBtn} onClick={exportar}>⬇ Exportar PDF</button>
      </div>

      {error && <div style={{ color: '#dc2626', marginBottom: 12 }}>{error}</div>}

      <div style={sh.tableScroll}>
        <table style={sh.table}>
          <thead>
            <tr>
              <th style={sh.th}>Cliente</th><th style={sh.th}>Banco</th><th style={sh.th}>Tipo de Crédito</th>
              <th style={sh.th}>Status</th><th style={sh.th}>Fecha</th><th style={sh.th}>Motivo</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={6} style={sh.empty}>Cargando...</td></tr>}
            {!loading && datos && datos.length === 0 && <tr><td colSpan={6} style={sh.empty}>Sin casos en el periodo seleccionado</td></tr>}
            {!loading && datos && datos.map(f => (
              <tr key={f.id}>
                <td style={sh.td}>{f.nombre_cliente || '(Sin nombre)'}</td>
                <td style={sh.td}>{f.banco}</td>
                <td style={sh.td}>{f.tipo_credito || 'Sin clasificar'}</td>
                <td style={sh.td}>
                  <span style={sh.pill(f.status === 'Rechazado' ? '#fde8e8' : '#eceef1', f.status === 'Rechazado' ? '#dc2626' : '#5c6472')}>{f.status}</span>
                </td>
                <td style={sh.td}>{f.fecha}</td>
                <td style={sh.td}>{f.motivo || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function ReporteExpedienteFormalizacion() {
  const filtroUsuariosKey = useFiltroUsuarios().join(',');
  const [datos, setDatos] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch(`${API}/reportes-crm/expediente-formalizacion`)
      .then(r => r.json())
      .then(d => (d.error ? setError(d.error) : setDatos(d)))
      .catch(() => setError('No se pudo cargar el reporte'))
      .finally(() => setLoading(false));
  }, [filtroUsuariosKey]);

  const exportar = () => descargarPdf(`${API}/reportes-crm/expediente-formalizacion/exportar`, 'expediente-pendiente-formalizacion.pdf');

  // Encabezados propios de este reporte: en Mayúsculas y minúsculas (no todo
  // en mayúsculas como el resto de los Reportes) y los del checklist más
  // chicos, para dejarle espacio a la columna Cliente y que el nombre quepa
  // en una sola línea.
  const thNormal = { ...sh.th, textTransform: 'none' };
  const thChecklist = { ...sh.th, textTransform: 'none', padding: '6px 4px', textAlign: 'center' };
  const colCount = 5 + CHECKLIST_EXPEDIENTE.length;

  return (
    <div>
      <div style={sh.toolbar}>
        <span style={sh.liveBadge}>🟢 En vivo · siempre hoy</span>
        <button style={sh.exportBtn} onClick={exportar}>⬇ Exportar PDF</button>
      </div>

      {error && <div style={{ color: '#dc2626', marginBottom: 12 }}>{error}</div>}

      <div style={sh.tableScroll}>
        <table style={sh.table}>
          <thead>
            <tr>
              <th style={{ ...thNormal, whiteSpace: 'nowrap' }}>Cliente</th>
              <th style={thNormal}>Banco</th>
              <th style={thNormal}>Entrada a Avalúo</th>
              <th style={thNormal}>Status Caso</th>
              <th style={thNormal}>Vigencia Crédito</th>
              {CHECKLIST_EXPEDIENTE.map(c => (
                <th key={c.campo} style={thChecklist}>{c.linea1}<br />{c.linea2}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={colCount} style={sh.empty}>Cargando...</td></tr>}
            {!loading && datos && datos.length === 0 && <tr><td colSpan={colCount} style={sh.empty}>No hay expedientes pendientes de formalización</td></tr>}
            {!loading && datos && datos.map(f => (
              <tr key={f.id}>
                <td style={{ ...sh.td, whiteSpace: 'nowrap' }}>{tituloCase(f.nombre_cliente) || '(Sin nombre)'}</td>
                <td style={sh.td}>{f.banco}</td>
                <td style={sh.td}>{f.fecha_entrada_avaluo || '—'}</td>
                <td style={sh.td}>{f.status_nombre}</td>
                <td style={sh.td}>{f.fecha_vigencia || '—'}</td>
                {CHECKLIST_EXPEDIENTE.map(c => (
                  <td key={c.campo} style={{ ...sh.td, textAlign: 'center' }}>{f[c.campo] ? '✓' : ''}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const ReportesCrmHome = ({ onVolver, onVerHipotecas, onVerNotificaciones, onVerHistorico }) => {
  const { isMobile } = useResponsive();
  const [tab, setTab] = useState('historico');
  const [anios, setAnios] = useState([]);
  const filtroUsuariosKey = useFiltroUsuarios().join(',');

  useEffect(() => {
    fetch(`${API}/reportes-crm/anios-disponibles`).then(r => r.json()).then(d => setAnios(Array.isArray(d) ? d : [])).catch(() => {});
  }, [filtroUsuariosKey]);

  // Mide el alto real del encabezado azul para que la fila de tabs se pegue
  // justo debajo (mismo patrón que --app-header-h en App.js / SeguimientoClientes.jsx).
  const headerRef = useRef(null);
  const [headerH, setHeaderH] = useState(56);
  useEffect(() => {
    const el = headerRef.current;
    if (!el) return;
    const medir = () => setHeaderH(el.offsetHeight);
    medir();
    const ro = new ResizeObserver(medir);
    ro.observe(el);
    window.addEventListener('resize', medir);
    return () => { ro.disconnect(); window.removeEventListener('resize', medir); };
  }, [isMobile]);

  const st = {
    container: { padding: isMobile ? 12 : 24, maxWidth: 1500, margin: '0 auto' },
    // Sin overflow:hidden aquí: un ancestro con overflow distinto de "visible"
    // se vuelve el contenedor de referencia de position:sticky de sus hijos,
    // y como este div no es el que realmente hace scroll (la página sí, él no),
    // eso rompe el sticky de frameHeader/tabs de abajo. El radio de las
    // esquinas se resuelve dándoselo también a frameHeader (arriba) y a
    // tableScroll de cada reporte (abajo), no recortando con overflow.
    frame: { backgroundColor: 'white', border: '1px solid #e5e7eb', borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' },
    // Sticky: mismo patrón (position sticky + var(--app-header-h)) que usan los
    // demás encabezados fijos del sistema (Prospectos, Seguimiento, Simuladores).
    frameHeader: {
      backgroundColor: '#1a3a6e', color: 'white', padding: isMobile ? '14px 16px' : '16px 22px',
      display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap',
      position: 'sticky', top: 'var(--app-header-h, 120px)', zIndex: 31,
      borderRadius: '12px 12px 0 0',
    },
    backBtn: { background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.28)', color: 'white', fontSize: 12.5, fontWeight: 'bold', borderRadius: 7, padding: '7px 12px', cursor: 'pointer' },
    title: { margin: 0, fontSize: 17, fontWeight: 'bold' },
    tabs: {
      display: 'flex', gap: 4, borderBottom: '1px solid #e5e7eb', padding: '0 14px', overflowX: 'auto',
      backgroundColor: 'white', position: 'sticky', top: `calc(var(--app-header-h, 120px) + ${headerH}px)`, zIndex: 30,
      boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
    },
    panel: { padding: isMobile ? 14 : '20px 22px 26px' },
  };
  const tabStyle = (active) => ({
    appearance: 'none', border: 'none', background: 'none', fontFamily: 'inherit',
    fontSize: 13, fontWeight: 600, color: active ? '#1a3a6e' : '#6b7280',
    padding: '14px 16px 12px', cursor: 'pointer', whiteSpace: 'nowrap',
    borderBottom: active ? '2.5px solid #f97316' : '2.5px solid transparent',
  });

  return (
    <div style={st.container}>
      <div style={st.frame}>
        <div ref={headerRef} style={st.frameHeader}>
          <button style={st.backBtn} onClick={onVolver}>← Dashboard</button>
          {onVerHipotecas && (
            <button style={st.backBtn} onClick={onVerHipotecas}>🏦 Hipotecas</button>
          )}
          {onVerNotificaciones && (
            <button style={st.backBtn} onClick={onVerNotificaciones}>🔔 Notificaciones</button>
          )}
          {onVerHistorico && (
            <button style={st.backBtn} onClick={onVerHistorico}>📜 Histórico</button>
          )}
          <h2 style={st.title}>📊 Reportes</h2>
        </div>
        <div style={st.tabs}>
          {TABS.map(t => (
            <button key={t.id} style={tabStyle(tab === t.id)} onClick={() => setTab(t.id)}>{t.label}</button>
          ))}
        </div>
        <div style={st.panel}>
          <FiltroUsuarios ancho={280} contenedorStyle={{ marginBottom: 16 }} />
          {tab === 'historico' && <ReporteHistorico anios={anios} />}
          {tab === 'evaluacion' && <ReporteRango tipo="evaluacion" anios={anios} />}
          {tab === 'firmados' && <ReporteRango tipo="firmados" anios={anios} />}
          {tab === 'porvencer' && <ReportePorVencer />}
          {tab === 'rechazos' && <ReporteRechazos />}
          {tab === 'formalizacion' && <ReporteExpedienteFormalizacion />}
        </div>
      </div>
    </div>
  );
};

// DropdownCheckbox también lo usa la pantalla Histórico (SeguimientoHistorico.jsx).
export { DropdownCheckbox };
export default ReportesCrmHome;
